import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faAlignJustify, faWallet, faLandmark } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/leis-auth.scss';


function HomeLoggedLeiScreen() {
    const [cad, setCad] = useState(false)
    const [listar, setListar] = useState(false)
    const [listLeiNum, setListLeiNum] = useState(false)
    const [listDecNum, setListDecNum] = useState(false)
    const [partido, setPartido] = useState(false)
    const [insti, setInsti] = useState(false)
    const [adm, setAdm] = useState(false)
    const nome = localStorage.getItem('nome');
    const nivel = localStorage.getItem('nivel');

    const verNivel = (nivel) => {
        if (nivel === "Administrador") {
            setAdm(true)
        }
    }

    useEffect(() => {
        verNivel(nivel)
    }, [nivel])

    if (listar) {
        return <Navigate to={{ pathname: '/restrito/leis/listar' }} />
    }

    if (cad) {
        return <Navigate to={{ pathname: '/restrito/leis/cadastrar' }} />
    }

    if (listLeiNum) {
        return <Navigate to={{ pathname: '/restrito/leis/indiceleis' }} />
    }

    if (listDecNum) {
        return <Navigate to={{ pathname: '/restrito/leis/indicedecretos' }} />
    }

    if (partido) {
        return <Navigate to={{ pathname: '/restrito/partido' }} />
    }

    if (insti) {
        return <Navigate to={{ pathname: '/restrito/institucional' }} />
    }

    return (
        <Fragment>
            <Head titulo="Transparência - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
                <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Card className='card-list' onClick={e => setCad(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Cadastrar Lei</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Listar Leis</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setPartido(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faWallet} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Liberação de Recursos</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setInsti(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faLandmark} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Módulo Institucional</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListLeiNum(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Índice de Leis</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListDecNum(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Índice de Decretos</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {adm ?
                    <Fragment>
                        <br /><br />
                        <Link to={'/restrito'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment> : ''}
            </Container>
            <Footer />
        </Fragment>
    );
}

export default HomeLoggedLeiScreen;